module.exports = __webpack_public_path__ + "static/media/myprofile.c8e68996.svg";